import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-signalsConfirmationModal',
  templateUrl: '../templates/confirmationModal.component.html'
})
export class ConfirmationModalComponent implements OnInit {
  errorMessage: string;
  details: string;
  title: string;
  message: string;

  constructor(private dialogRef: MatDialogRef<ConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA)
    private data: { CancelResult: boolean, details: any, title: string, message: string }) {
    try {
      this.details = JSON.stringify(data.details, null, 2);
      this.title = data.title;
      this.message = data.message;
    } catch (ex) {
      console.log(ex);
      this.details = data.details;
    }
  }

  ngOnInit() {

  }

  accept() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/confirmationModal.component.ts